export const categories = [
  { id: "all", name: "全部", slug: "all" },
  { id: "action", name: "动作片", slug: "action" },
  { id: "comedy", name: "喜剧片", slug: "comedy" },
  { id: "drama", name: "剧情片", slug: "drama" },
  { id: "scifi", name: "科幻片", slug: "scifi" },
  { id: "horror", name: "恐怖片", slug: "horror" },
  { id: "romance", name: "爱情片", slug: "romance" },
  { id: "animation", name: "动漫", slug: "animation" },
  { id: "documentary", name: "纪录片", slug: "documentary" },
  { id: "variety", name: "综艺", slug: "variety" },
  { id: "tvseries", name: "电视剧", slug: "tvseries" },
];

export const movies = [
  {
    id: 1,
    title: "流浪地球3",
    slug: "the-wandering-earth-3",
    category: "scifi",
    year: 2025,
    rating: 8.5,
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    region: "中国大陆",
    duration: "148分钟",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，年轻一代挺身而出，展开争分夺秒的生死之战。本片延续前作宏大的科幻世界观，视觉特效全面升级，讲述人类命运共同体的壮丽史诗。",
    posterUrl: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20Earth%20traveling%20through%20space%20with%20giant%20thrusters%2C%20dramatic%20cosmic%20background%20with%20stars%20and%20nebula%2C%20warm%20orange%20and%20blue%20tones%2C%20cinematic%20lighting%2C%20Chinese%20blockbuster%20style%2C%20clean%20composition&width=400&height=600&seq=movie-wandering-earth-3&orientation=portrait",
    featured: true,
  },
  {
    id: 2,
    title: "满江红2",
    slug: "full-river-red-2",
    category: "drama",
    year: 2025,
    rating: 8.2,
    director: "张艺谋",
    actors: ["沈腾", "易烊千玺", "张译"],
    region: "中国大陆",
    duration: "159分钟",
    description: "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一群义士为了揭露真相，在宰相驻地展开了一场惊心动魄的暗战。层层反转，悬念迭起，最终揭开一段尘封的历史真相。",
    posterUrl: "https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20movie%20poster%20with%20traditional%20Song%20Dynasty%20aesthetics%2C%20ink%20wash%20painting%20style%2C%20dark%20red%20and%20black%20tones%2C%20mysterious%20atmosphere%2C%20ancient%20Chinese%20architecture%20silhouette%2C%20cinematic%20composition&width=400&height=600&seq=movie-full-river-red-2&orientation=portrait",
    featured: true,
  },
  {
    id: 3,
    title: "哪吒之魔童闹海",
    slug: "nezha-2",
    category: "animation",
    year: 2025,
    rating: 8.8,
    director: "饺子",
    actors: ["吕艳婷", "囧森瑟夫", "瀚墨"],
    region: "中国大陆",
    duration: "144分钟",
    description: "天劫之后，哪吒、敖丙的灵魂虽保住，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，但过程中却遇到重重困难。哪吒与敖丙的命运将走向何方？一段奇幻冒险就此展开。",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%20featuring%20a%20rebellious%20young%20deity%20with%20fire%20elements%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20dynamic%20action%20pose%2C%20traditional%20Chinese%20mythology%20style%20mixed%20with%20modern%20animation%2C%20dramatic%20lighting%2C%20epic%20scale&width=400&height=600&seq=movie-nezha-2&orientation=portrait",
    featured: true,
  },
  {
    id: 4,
    title: "飞驰人生3",
    slug: "pegasus-3",
    category: "comedy",
    year: 2025,
    rating: 7.9,
    director: "韩寒",
    actors: ["沈腾", "范丞丞", "尹正"],
    region: "中国大陆",
    duration: "128分钟",
    description: "曾经的冠军车手张驰，再次面临人生的重大抉择。在好友和家人的支持下，他决定重返赛道，挑战自我极限。速度与激情的碰撞，笑中带泪的赛车故事，献给每一个不甘平凡的人。",
    posterUrl: "https://readdy.ai/api/search-image?query=Racing%20comedy%20movie%20poster%20with%20formula%20car%20on%20desert%20track%2C%20warm%20golden%20sunset%20lighting%2C%20dust%20and%20speed%20effects%2C%20Chinese%20racing%20aesthetic%2C%20cinematic%20wide%20shot%2C%20dramatic%20sky%2C%20clean%20modern%20design&width=400&height=600&seq=movie-pegasus-3&orientation=portrait",
    featured: false,
  },
  {
    id: 5,
    title: "唐人街探案4",
    slug: "detective-chinatown-4",
    category: "comedy",
    year: 2025,
    rating: 7.6,
    director: "陈思诚",
    actors: ["王宝强", "刘昊然", "肖央"],
    region: "中国大陆",
    duration: "136分钟",
    description: "唐仁和秦风接到一起离奇的跨国案件，两人远赴伦敦展开调查。异国风情与悬疑推理的完美结合，笑料百出又烧脑十足，这对黄金搭档再次联手破解谜团。",
    posterUrl: "https://readdy.ai/api/search-image?query=Comedy%20mystery%20movie%20poster%20with%20London%20landmarks%20background%2C%20two%20detectives%20in%20contrasting%20styles%2C%20warm%20and%20cool%20color%20contrast%2C%20playful%20yet%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20urban%20night%20scene&width=400&height=600&seq=movie-detective-chinatown-4&orientation=portrait",
    featured: false,
  },
  {
    id: 6,
    title: "长津湖之水门桥",
    slug: "water-gate-bridge",
    category: "action",
    year: 2024,
    rating: 8.1,
    director: "陈凯歌",
    actors: ["吴京", "易烊千玺", "朱亚文"],
    region: "中国大陆",
    duration: "149分钟",
    description: "以抗美援朝战争第二次战役中的长津湖战役为背景，讲述了志愿军七连战士们在结束了新兴里和下碣隅里的战斗之后，又接到了更艰巨的任务——炸毁水门桥，阻断美军撤退的道路。",
    posterUrl: "https://readdy.ai/api/search-image?query=War%20epic%20movie%20poster%20with%20snowy%20mountain%20battlefield%2C%20soldiers%20in%20winter%20combat%20gear%2C%20dramatic%20cold%20blue%20and%20warm%20orange%20contrast%2C%20heroic%20stance%2C%20cinematic%20scale%2C%20historical%20atmosphere%2C%20powerful%20composition&width=400&height=600&seq=movie-water-gate-bridge&orientation=portrait",
    featured: false,
  },
  {
    id: 7,
    title: "消失的她2",
    slug: "lost-in-the-stars-2",
    category: "drama",
    year: 2025,
    rating: 7.8,
    director: "崔睿",
    actors: ["朱一龙", "倪妮", "文咏珊"],
    region: "中国大陆",
    duration: "122分钟",
    description: "何非的妻子在海外旅行中再次神秘失踪，他疯狂寻找却毫无头绪。当一位陌生女子声称是他的妻子时，真相的漩涡将他卷入更深的谜局。悬念层层递进，结局出人意料。",
    posterUrl: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20with%20tropical%20island%20night%20scene%2C%20mysterious%20woman%20silhouette%2C%20deep%20blue%20and%20warm%20gold%20tones%2C%20noir%20atmosphere%2C%20cinematic%20lighting%2C%20intrigue%20and%20mystery%2C%20artistic%20composition&width=400&height=600&seq=movie-lost-in-the-stars-2&orientation=portrait",
    featured: false,
  },
  {
    id: 8,
    title: "封神第二部",
    slug: "creation-of-the-gods-2",
    category: "action",
    year: 2025,
    rating: 8.3,
    director: "乌尔善",
    actors: ["费翔", "黄渤", "于适"],
    region: "中国大陆",
    duration: "152分钟",
    description: "殷商大军兵临西岐，姜子牙率众仙与姬发等西岐军民奋起抵抗。神魔大战全面爆发，封神榜的秘密也逐渐浮出水面。中国神话史诗巨制，视觉盛宴震撼人心。",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20mythology%20epic%20movie%20poster%20with%20ancient%20gods%20and%20warriors%2C%20divine%20battle%20scene%2C%20gold%20and%20crimson%20color%20scheme%2C%20traditional%20Chinese%20elements%2C%20majestic%20scale%2C%20dramatic%20sky%2C%20epic%20fantasy%20atmosphere&width=400&height=600&seq=movie-creation-of-the-gods-2&orientation=portrait",
    featured: true,
  },
  {
    id: 9,
    title: "热辣滚烫2",
    slug: "yolo-2",
    category: "drama",
    year: 2025,
    rating: 7.5,
    director: "贾玲",
    actors: ["贾玲", "雷佳音", "张小斐"],
    region: "中国大陆",
    duration: "130分钟",
    description: "乐莹在经历了人生的重大转变后，迎来了新的挑战和机遇。她用自己的方式证明，每个人都可以成为自己生活的主角。温暖治愈的励志故事，笑泪交织的人生百态。",
    posterUrl: "https://readdy.ai/api/search-image?query=Inspirational%20drama%20movie%20poster%20with%20warm%20golden%20hour%20lighting%2C%20boxing%20gym%20setting%2C%20strong%20female%20energy%2C%20soft%20warm%20tones%2C%20emotional%20depth%2C%20modern%20Chinese%20urban%20aesthetic%2C%20hopeful%20atmosphere&width=400&height=600&seq=movie-yolo-2&orientation=portrait",
    featured: false,
  },
  {
    id: 10,
    title: "熊出没·重启未来",
    slug: "boonie-bears-future",
    category: "animation",
    year: 2025,
    rating: 7.3,
    director: "林永长",
    actors: ["张秉君", "谭笑", "张伟"],
    region: "中国大陆",
    duration: "98分钟",
    description: "光头强和熊大熊二意外穿越到未来世界，面对高度发达的科技城市和未知的挑战，他们必须携手合作才能回到自己的时代。合家欢动画大作，寓教于乐。",
    posterUrl: "https://readdy.ai/api/search-image?query=Family%20animated%20movie%20poster%20with%20futuristic%20city%20background%2C%20two%20bears%20and%20a%20human%20character%20in%20adventure%20pose%2C%20bright%20vibrant%20colors%2C%20sci-fi%20elements%20mixed%20with%20forest%20nature%2C%20playful%20and%20warm%20atmosphere%2C%20Chinese%20animation%20style&width=400&height=600&seq=movie-boonie-bears-future&orientation=portrait",
    featured: false,
  },
  {
    id: 11,
    title: "志愿军：雄兵出击2",
    slug: "volunteers-2",
    category: "action",
    year: 2025,
    rating: 8.0,
    director: "陈凯歌",
    actors: ["唐国强", "王砚辉", "刘劲"],
    region: "中国大陆",
    duration: "142分钟",
    description: "1950年，朝鲜战争爆发。中国人民志愿军跨过鸭绿江，与装备精良的联合国军展开殊死较量。本片全景式展现抗美援朝战争历程，致敬最可爱的人。",
    posterUrl: "https://readdy.ai/api/search-image?query=Historical%20war%20movie%20poster%20with%20soldiers%20crossing%20river%20at%20dawn%2C%20dramatic%20sky%2C%20cold%20winter%20atmosphere%2C%20heroic%20composition%2C%20muted%20blue-gray%20and%20warm%20golden%20tones%2C%20epic%20scale%2C%20Chinese%20historical%20drama%20style&width=400&height=600&seq=movie-volunteers-2&orientation=portrait",
    featured: false,
  },
  {
    id: 12,
    title: "默杀",
    slug: "a-place-called-silence",
    category: "horror",
    year: 2025,
    rating: 7.1,
    director: "柯汶利",
    actors: ["王传君", "张钧甯", "吴镇宇"],
    region: "中国大陆",
    duration: "115分钟",
    description: "一所女子中学里，接连发生诡异的命案。新来的语文老师逐渐发现，沉默的背后隐藏着令人不寒而栗的真相。校园悬疑惊悚片，层层反转令人窒息。",
    posterUrl: "https://readdy.ai/api/search-image?query=Horror%20thriller%20movie%20poster%20with%20dark%20school%20corridor%2C%20mysterious%20shadows%2C%20cold%20blue%20and%20dark%20tones%2C%20eerie%20atmosphere%2C%20rain%20on%20window%2C%20suspenseful%20composition%2C%20Chinese%20horror%20aesthetic%2C%20minimalist%20yet%20chilling&width=400&height=600&seq=movie-a-place-called-silence&orientation=portrait",
    featured: false,
  },
  {
    id: 13,
    title: "草木人间",
    slug: "dwelling-by-the-west-lake",
    category: "romance",
    year: 2025,
    rating: 7.4,
    director: "顾晓刚",
    actors: ["吴磊", "蒋勤勤", "陈建斌"],
    region: "中国大陆",
    duration: "118分钟",
    description: "西湖边长大的青年阿磊，在追寻梦想的过程中，邂逅了一段刻骨铭心的爱情。诗意江南与青春热望交织，一部关于成长、爱情与归属的文艺佳作。",
    posterUrl: "https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%20with%20West%20Lake%20landscape%2C%20soft%20spring%20colors%2C%20cherry%20blossoms%2C%20young%20couple%20silhouette%2C%20poetic%20Chinese%20aesthetic%2C%20warm%20golden%20hour%20light%2C%20dreamy%20atmosphere%2C%20elegant%20composition&width=400&height=600&seq=movie-dwelling-by-the-west-lake&orientation=portrait",
    featured: false,
  },
  {
    id: 14,
    title: "大江大河3",
    slug: "like-a-flowing-river-3",
    category: "tvseries",
    year: 2025,
    rating: 8.6,
    director: "孔笙",
    actors: ["王凯", "杨烁", "董子健"],
    region: "中国大陆",
    duration: "40集",
    description: "宋运辉、雷东宝、杨巡三人在改革开放的浪潮中继续书写各自的人生。从国企改革到个体经济崛起，他们的命运与时代紧密相连，展现中国社会深刻变革。",
    posterUrl: "https://readdy.ai/api/search-image?query=Period%20drama%20TV%20series%20poster%20with%20three%20men%20in%20different%20professions%2C%201990s%20Chinese%20urban%20background%2C%20warm%20nostalgic%20tones%2C%20reform%20and%20opening%20up%20era%20aesthetic%2C%20dramatic%20lighting%2C%20ensemble%20cast%2C%20epic%20storytelling%20vibe&width=400&height=600&seq=movie-like-a-flowing-river-3&orientation=portrait",
    featured: false,
  },
  {
    id: 15,
    title: "奔跑吧·生态篇",
    slug: "keep-running-eco",
    category: "variety",
    year: 2025,
    rating: 7.0,
    director: "姚译添",
    actors: ["李晨", "郑恺", "杨颖", "白鹿", "周深"],
    region: "中国大陆",
    duration: "12期",
    description: "奔跑吧兄弟团走进祖国大好河山，在绿水青山间展开一场场趣味横生的挑战。寓教于乐，展现中国生态文明建设成就，传递环保理念。",
    posterUrl: "https://readdy.ai/api/search-image?query=Variety%20show%20poster%20with%20group%20of%20celebrities%20running%20in%20beautiful%20natural%20landscape%2C%20bright%20energetic%20colors%2C%20green%20mountains%20and%20clear%20waters%2C%20joyful%20atmosphere%2C%20Chinese%20outdoor%20variety%20aesthetic%2C%20sunny%20day%2C%20dynamic%20composition&width=400&height=600&seq=movie-keep-running-eco&orientation=portrait",
    featured: false,
  },
  {
    id: 16,
    title: "深海",
    slug: "deep-sea",
    category: "animation",
    year: 2024,
    rating: 7.7,
    director: "田晓鹏",
    actors: ["苏鑫", "王亭文"],
    region: "中国大陆",
    duration: "112分钟",
    description: "一个沉浸在悲伤中的女孩参宿，误入了一个梦幻般的深海世界，邂逅了神秘的南河，开启了一场独特的生命之旅。粒子水墨动画开创之作，视觉惊艳绝伦。",
    posterUrl: "https://readdy.ai/api/search-image?query=Artistic%20animated%20movie%20poster%20with%20colorful%20underwater%20fantasy%20world%2C%20particle%20ink%20painting%20style%2C%20vibrant%20blues%20and%20purples%20with%20warm%20light%2C%20dreamy%20jellyfish%20and%20sea%20creatures%2C%20Chinese%20animation%20innovation%2C%20mesmerizing%20visual%20style&width=400&height=600&seq=movie-deep-sea&orientation=portrait",
    featured: false,
  },
  {
    id: 17,
    title: "年会不能停！2",
    slug: "johnny-keep-walking-2",
    category: "comedy",
    year: 2025,
    rating: 8.0,
    director: "董润年",
    actors: ["大鹏", "白客", "庄达菲"],
    region: "中国大陆",
    duration: "120分钟",
    description: "胡建林在集团总部站稳脚跟后，新的挑战接踵而至。一场更加荒诞的职场喜剧即将上演，笑到停不下来的同时，也折射出当代打工人的酸甜苦辣。",
    posterUrl: "https://readdy.ai/api/search-image?query=Workplace%20comedy%20movie%20poster%20with%20office%20setting%2C%20funny%20exaggerated%20expressions%2C%20modern%20corporate%20aesthetic%2C%20bright%20warm%20lighting%2C%20humorous%20tone%2C%20Chinese%20urban%20comedy%20style%2C%20clean%20composition&width=400&height=600&seq=movie-johnny-keep-walking-2&orientation=portrait",
    featured: false,
  },
  {
    id: 18,
    title: "地球脉动III",
    slug: "planet-earth-3",
    category: "documentary",
    year: 2025,
    rating: 9.5,
    director: "BBC Studios",
    actors: [],
    region: "英国",
    duration: "8集",
    description: "历时五年制作，走访全球43个国家，以最先进的拍摄技术记录地球上最壮丽的自然奇观和野生动物故事。每一帧都是壁纸，每一个故事都震撼心灵。",
    posterUrl: "https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20featuring%20Earth%20from%20space%20and%20diverse%20wildlife%20montage%2C%20stunning%20natural%20landscapes%2C%20vibrant%20colors%2C%20majestic%20animals%2C%20cinematic%20photography%20style%2C%20awe-inspiring%20composition%2C%20blue%20and%20green%20tones&width=400&height=600&seq=movie-planet-earth-3&orientation=portrait",
    featured: false,
  },
];

export const articles = [
  {
    id: 1,
    title: "2025年暑期档最值得期待的十部国产大片",
    slug: "summer-2025-top-10",
    category: "news",
    excerpt: "暑期档历来是国产大片的必争之地。2025年暑期档集结了多部重磅作品，从科幻巨制到悬疑惊悚，类型丰富多样。本文为你盘点最值得期待的十部影片。",
    content: `暑期档作为全年最重要的电影档期之一，每年都有大量优质国产电影集中上映。2025年暑期档更是星光熠熠，多部重量级作品蓄势待发。

科幻迷们期待已久的《流浪地球3》将成为暑期档的开路先锋。郭帆导演在前两部的基础上，将中国科幻电影推向了新的高度。据悉，本片在视觉特效上投入巨大，太空场景的呈现将更加震撼。

动画电影方面，《哪吒之魔童闹海》无疑是最大的看点。饺子导演用五年时间精心打磨，在技术层面实现了全面突破。影片在保留前作幽默风格的同时，故事格局全面升级。

喜剧片市场同样热闹，《飞驰人生3》和《唐人街探案4》都选择在暑期档上映。沈腾、王宝强等喜剧大咖的回归，必将为观众带来无尽欢笑。

此外，多部中小成本影片也选择在暑期档发力，类型涵盖悬疑、爱情、文艺等，为观众提供了丰富的观影选择。`,
    publishedAt: "2025-07-15",
    coverUrl: "https://readdy.ai/api/search-image?query=Summer%20cinema%20movie%20posters%20collage%2C%20warm%20golden%20sunlight%2C%20film%20festival%20atmosphere%2C%20Chinese%20movie%20theater%20exterior%2C%20popcorn%20and%20film%20reel%2C%20vibrant%20and%20exciting%20mood%2C%20editorial%20photography&width=800&height=450&seq=article-summer-2025&orientation=landscape",
  },
  {
    id: 2,
    title: "中国科幻电影的崛起之路：从《流浪地球》到未来",
    slug: "chinese-scifi-rising",
    category: "feature",
    excerpt: "从《流浪地球》开启中国科幻电影元年，到如今科幻题材百花齐放，中国科幻电影正以惊人的速度成长。本文将深度解析中国科幻电影的发展历程与未来趋势。",
    content: `如果说2019年的《流浪地球》为中国科幻电影打开了大门，那么2025年的中国科幻电影已经进入了一个全新的黄金时代。

技术层面，中国电影工业的特效水平已经达到国际一流水准。《流浪地球》系列、《独行月球》、《宇宙探索编辑部》等作品，展示了中国电影人在视觉呈现上的长足进步。越来越多的特效镜头实现了国产化，成本降低的同时品质不断提升。

叙事层面，中国科幻电影找到了属于自己的表达方式。与好莱坞强调个人英雄主义不同，中国科幻更注重集体主义精神和人类命运共同体理念。《流浪地球》中"带着地球去流浪"的设定，就是中国文化独特价值观的体现。

产业链层面，从上游的科幻文学创作到下游的衍生品开发，中国科幻电影的全产业链正在逐步完善。刘慈欣、郝景芳等作家的作品不断被搬上大银幕，科幻IP的商业价值正在被充分挖掘。

展望未来，中国科幻电影仍面临诸多挑战，但前景光明。随着更多优秀人才的加入和市场的成熟，中国科幻电影的黄金时代才刚刚开始。`,
    publishedAt: "2025-06-28",
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20cinema%20concept%20art%20with%20futuristic%20cityscape%2C%20warm%20orange%20and%20deep%20blue%20tones%2C%20spaceship%20and%20technology%20elements%2C%20cinematic%20atmosphere%2C%20artistic%20and%20inspiring%20composition%2C%20Chinese%20aesthetic%20future%20vision&width=800&height=450&seq=article-chinese-scifi&orientation=landscape",
  },
  {
    id: 3,
    title: "春节档票房复盘：哪部电影最值得二刷？",
    slug: "spring-festival-box-office-review",
    category: "review",
    excerpt: "2025年春节档硝烟散尽，多部影片创造了不俗的票房成绩。本文从口碑、票房、观影体验等多个维度，为你深度复盘春节档各影片表现。",
    content: `2025年春节档以破纪录的总票房成绩圆满收官。多部类型各异的影片为观众奉上了一场丰盛的光影盛宴。

票房冠军花落《哪吒之魔童闹海》，凭借前作积累的超高人气和过硬的质量，影片上映后一路领跑。饺子导演用精湛的动画技术和深刻的主题表达，征服了全年龄段观众。

口碑方面，《封神第二部》异军突起，豆瓣评分高达8.3分。乌尔善导演构建的中国神话史诗世界愈发宏大，演员的精彩演绎和震撼的视觉效果获得了影评人的一致好评。

《热辣滚烫2》则凭借温暖治愈的故事，赢得了女性观众的广泛共鸣。贾玲用真诚的表演和细腻的情感处理，让这部续作在口碑上不输前作。

对于观众来说，这个春节档影片整体质量上乘，值得二刷甚至三刷的好片不少。无论你喜欢哪种类型，都能找到适合自己的那部电影。`,
    publishedAt: "2025-03-05",
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%20New%20Year%20cinema%20atmosphere%20with%20red%20lanterns%20and%20movie%20posters%2C%20festive%20celebration%20mood%2C%20warm%20red%20and%20gold%20tones%2C%20theater%20interior%20with%20audience%2C%20cultural%20elements%2C%20joyful%20and%20warm%20ambiance&width=800&height=450&seq=article-spring-festival&orientation=landscape",
  },
];

export const faqs = [
  {
    question: "春夜影院如何免费在线观看电影？",
    answer: "春夜影院提供完全免费的在线观影服务。您只需访问春夜影院官网，在首页或分类页面浏览您感兴趣的电影，点击播放按钮即可开始观看。无需注册、无需付费，所有影片均为高清蓝光画质，流畅播放不卡顿。",
  },
  {
    question: "春夜影院支持手机版观看吗？",
    answer: "是的，春夜影院完美支持手机版观看。我们的网站采用响应式设计，自动适配各种屏幕尺寸。无论您使用iPhone、Android手机还是平板电脑，都能获得流畅的观影体验。手机版同样提供蓝光高清画质。",
  },
  {
    question: "春夜影院的影片画质如何？",
    answer: "春夜影院所有影片均提供蓝光1080P高清画质，部分热门影片更支持4K超清画质。我们采用先进的视频编码技术和CDN加速节点，确保影片播放清晰流畅、不缓冲、不卡顿，让您享受影院级的观影体验。",
  },
  {
    question: "春夜影院需要下载APP吗？",
    answer: "不需要。春夜影院是纯网页版在线影院，无需下载任何APP或插件，打开浏览器即可观看。我们建议将春夜影院官网添加到浏览器书签或手机桌面，方便下次快速访问。",
  },
  {
    question: "春夜影院的影片更新频率是怎样的？",
    answer: "春夜影院每日更新最新上映的电影、电视剧和综艺节目。我们的内容团队会在第一时间更新热门影片资源，确保您能尽快观看到最新内容。一般电影上映后24-48小时内即可在春夜影院观看。",
  },
];